import { useEffect, useState } from "react"
import { Home } from "../home/Home";
import HomeMobile from "../HomeMobile/HomeMobile";

const HomeDriver = () => {
    

    const [device, setDevice] = useState("");

    useEffect(() => {
        if(window.innerWidth < 1000){
            setDevice("mobile");
            console.log("Mobile")
        }else{
            setDevice("desktop");
            console.log("Desktop")
        }
    }, [])

    return (
        <div>
            { device === "mobile" && <HomeMobile /> }
            { device === "desktop" && <Home /> }
        </div>
    )
}

export default HomeDriver